import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Menu from "@rui/Menu";
import { Row } from "@rui/Stack";

export const Popover = styled(Menu)(({ theme }) => ({
  padding: theme.spacing(2),
  color: theme.palette.shades.neutral[600],
  "& .MuiPaper-root": {
    minWidth: "250px",
    maxWidth: "250px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.shades.neutral[700],
}));

export const Heading = styled(Row)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const BenchmarkDescription = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  lineHeight: 16 / 14,
  color: theme.palette.shades.neutral[600],
}));

export const Benchmark = styled("span")(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.shades.neutral[600],
}));
